export function convertFileToBinaryString(file: File) {
    const reader = new FileReader();
    reader.onload = (e) => {
        const binaryString = e.target?.result as string; 
    };
    reader.readAsArrayBuffer(file); 
}

export function arrayBufferToBinaryString(buffer: ArrayBuffer): string {
    const bytes = new Uint8Array(buffer);
    let binaryString = '';
    bytes.forEach((byte) => {
        binaryString += String.fromCharCode(byte);
    });
    return binaryString;
}